// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectedLink{
    color: #ffa500 !important;
}

  
  /* Add styles to show the sidebar when it's open */
  .side-nav-bar.show-sidebar {
    left: 0;
  }
  /* Add styles for the side-nav-bar */
.side-nav-bar {
    position: fixed;
    top: 55px;
    left: -300px;
    width: 216px;
    height: 100vh;
    background-color: #292c2f;
    transition: left 0.3s ease;
    z-index: 1000;
  }
  
  /* Add styles for sidebar items */
  .sidebar-item {
    display: flex;
    align-items: center;
    padding: 4px;
    color: #ffffff;
    text-decoration: none;
    transition: background-color 0.2s ease;
  }
  
  .sidebar-item i {
    margin-left: 10px;
    padding-right: 10px;
    text-decoration: none;
    font-size: 18px;
    color: white;
    display: block;
    cursor: pointer;
  }
  ul {
    padding: 10px;
  }
  
  li {
    font-size: 18px;
    color: white;
    display: block;
    cursor: pointer;
  }
  
  /* Add styles for active sidebar item */
  
  /* Add styles for sidebar items on hover */
  .sidebar-item:hover span {
    color: #ffa500;
  }

  /* Add styles for icon on hover */
.sidebar-item:hover i {
    color: #ffa500;
  }
`, "",{"version":3,"sources":["webpack://./src/app/side-nav-bar/side-nav-bar.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;;EAGE,kDAAkD;EAClD;IACE,OAAO;EACT;EACA,oCAAoC;AACtC;IACI,eAAe;IACf,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,aAAa;EACf;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;EACA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA,uCAAuC;;EAEvC,0CAA0C;EAC1C;IACE,cAAc;EAChB;;EAEA,iCAAiC;AACnC;IACI,cAAc;EAChB","sourcesContent":[".selectedLink{\n    color: #ffa500 !important;\n}\n\n  \n  /* Add styles to show the sidebar when it's open */\n  .side-nav-bar.show-sidebar {\n    left: 0;\n  }\n  /* Add styles for the side-nav-bar */\n.side-nav-bar {\n    position: fixed;\n    top: 55px;\n    left: -300px;\n    width: 216px;\n    height: 100vh;\n    background-color: #292c2f;\n    transition: left 0.3s ease;\n    z-index: 1000;\n  }\n  \n  /* Add styles for sidebar items */\n  .sidebar-item {\n    display: flex;\n    align-items: center;\n    padding: 4px;\n    color: #ffffff;\n    text-decoration: none;\n    transition: background-color 0.2s ease;\n  }\n  \n  .sidebar-item i {\n    margin-left: 10px;\n    padding-right: 10px;\n    text-decoration: none;\n    font-size: 18px;\n    color: white;\n    display: block;\n    cursor: pointer;\n  }\n  ul {\n    padding: 10px;\n  }\n  \n  li {\n    font-size: 18px;\n    color: white;\n    display: block;\n    cursor: pointer;\n  }\n  \n  /* Add styles for active sidebar item */\n  \n  /* Add styles for sidebar items on hover */\n  .sidebar-item:hover span {\n    color: #ffa500;\n  }\n\n  /* Add styles for icon on hover */\n.sidebar-item:hover i {\n    color: #ffa500;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
